export default function PropertyMap({ lat, lng, title }) {
  if (!lat || !lng) return null;
  const d = 0.012;
  const bbox = `${lng - d}%2C${lat - d}%2C${lng + d}%2C${lat + d}`;
  const src = `https://www.openstreetmap.org/export/embed.html?bbox=${bbox}&layer=mapnik&marker=${lat}%2C${lng}`;
  return (
    <div data-testid="property-map" className="border border-[#0A1128]/12 bg-white p-8 mt-14">
      <h2 className="font-serif text-2xl text-[#0A1128] mb-5">Location</h2>
      <div className="overflow-hidden border border-[#0A1128]/10">
        <iframe
          title={`Map of ${title}`}
          src={src}
          className="w-full h-[360px]"
          loading="lazy"
          style={{ border: 0 }}
        />
      </div>
      <a
        href={`https://www.openstreetmap.org/?mlat=${lat}&mlon=${lng}#map=15/${lat}/${lng}`}
        target="_blank" rel="noreferrer"
        className="inline-block mt-4 text-sm text-[var(--gold)] link-underline"
      >
        View larger map
      </a>
    </div>
  );
}
